import { render, staticRenderFns } from "./UserInfoPopup.vue?vue&type=template&id=f96ddc34&scoped=true"
import script from "./UserInfoPopup.vue?vue&type=script&lang=js"
export * from "./UserInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./UserInfoPopup.vue?vue&type=style&index=0&id=f96ddc34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96ddc34",
  null
  
)

export default component.exports